import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() left;
  @Input() top;
  @Input() widthHeight;
  
  constructor() { }
 

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/ui/loader/loader.component.ts